import React, { useRef, useState } from 'react';

function fmtSize(b) {
  if (b < 1048576) return Math.round(b / 1024) + 'KB';
  return (b / 1048576).toFixed(1) + 'MB';
}

export default function FdDropBar({ files = [], onChange, maxFiles = 5 }) {
  const inputRef = useRef();
  const [drag, setDrag] = useState(false);

  function addFiles(incoming) {
    const combined = [...files];
    for (const f of incoming) {
      if (combined.length >= maxFiles) break;
      if (!combined.find(x => x.name === f.name && x.size === f.size)) combined.push(f);
    }
    onChange(combined);
  }

  function remove(i) {
    const next = [...files];
    next.splice(i, 1);
    onChange(next);
  }

  const hasFiles = files.length > 0;

  return (
    <div
      onDragOver={e => { e.preventDefault(); setDrag(true); }}
      onDragLeave={e => { if (!e.currentTarget.contains(e.relatedTarget)) setDrag(false); }}
      onDrop={e => { e.preventDefault(); setDrag(false); addFiles([...e.dataTransfer.files]); }}
      style={{
        border: '1.5px dashed ' + (drag ? '#0085CA' : '#C5D8E8'),
        borderRadius: 8,
        marginTop: 8,
        background: drag ? '#EEF7FD' : '#F8FBFD',
        padding: '6px 12px',
        boxSizing: 'border-box',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 6,
        minHeight: 36,
        transition: 'border-color .15s, background .15s',
        cursor: files.length < maxFiles ? 'pointer' : 'default',
      }}
      onClick={() => files.length < maxFiles && inputRef.current.click()}
    >
      <input
        ref={inputRef}
        type="file"
        multiple
        accept="image/*,.pdf,.doc,.docx,.txt"
        style={{ display: 'none' }}
        onChange={e => { addFiles([...e.target.files]); e.target.value = ''; }}
      />

      {/* Chips de archivos */}
      {files.map((f, i) => {
        const isImg = f.type?.startsWith('image/');
        return (
          <div key={i}
            onClick={e => e.stopPropagation()}
            style={{
              display: 'flex', alignItems: 'center', gap: 5,
              height: 24, padding: '0 6px 0 5px',
              borderRadius: 20, background: '#fff',
              border: '1px solid #C5D8E8',
              flexShrink: 0,
            }}>
            {isImg
              ? <img src={URL.createObjectURL(f)} alt="" style={{ width: 14, height: 14, borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }}/>
              : <span style={{ fontSize: 11, color: '#0085CA', flexShrink: 0 }}>📄</span>
            }
            <span style={{ fontSize: 11, fontWeight: 500, color: '#374151', maxWidth: 120, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {f.name}
            </span>
            <span style={{ fontSize: 10, color: '#9CA3AF', flexShrink: 0 }}>{fmtSize(f.size)}</span>
            <button
              type="button"
              onClick={e => { e.stopPropagation(); remove(i); }}
              style={{ width: 14, height: 14, borderRadius: '50%', border: 'none', background: '#E0EEF7', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 9, color: '#5B8DB8', flexShrink: 0, padding: 0 }}>
              ×
            </button>
          </div>
        );
      })}

      {/* Texto placeholder cuando no hay archivos o hay espacio */}
      {files.length < maxFiles && (
        <span style={{ fontSize: 12, color: drag ? '#0085CA' : '#9CA3AF', fontWeight: drag ? 600 : 400, userSelect: 'none', flexShrink: 0 }}>
          {hasFiles
            ? <span style={{ color: '#C5D8E8' }}>+</span>
            : <><span style={{ color: '#0085CA', fontWeight: 600 }}>Adjuntar archivo</span><span className="fd-dropbar-hint" style={{ color: '#B0C4D8' }}> · arrastra aquí · PNG, JPG, PDF, Word</span></>
          }
        </span>
      )}
    </div>
  );
}
